import { useRef, forwardRef, ForwardedRef, Dispatch, SetStateAction } from 'react';
import { ICmsDocument, IVisualBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/collections/VisualBlock/VisualBlock.styles';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import VisualBlockNavigation from '@features/cms/components/collections/VisualBlock/VisualBlockNavigation/VisualBlockNavigation';
import VoxboxWidget from '@features/cms/components/collections/VoxboxWidget/VoxboxWidget';
import RenderMedia from '@utils/RenderMedia';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
type PropsType = {
  data: IVisualBlock;
  subpages?: ICmsDocument[];
  categorySlug?: string;
  activeSlug?: string;
  hasProducts?: boolean;
  setNewActiveSlug?: Dispatch<SetStateAction<string>>;
  isFirst?: boolean;
};
const VisualBlock = forwardRef(({
  data,
  subpages = [],
  categorySlug = '',
  activeSlug = '',
  setNewActiveSlug = undefined,
  hasProducts = false,
  isFirst = false
}: PropsType, ref: ForwardedRef<HTMLDivElement>) => {
  const titleColor = data.headerColor || theme.rawColors.neutralWhite;
  const {
    images,
    imagesWithBlur,
    videos,
    header,
    thumbnailsWithBlur
  } = data;
  const hoverRef = useRef<HTMLElement>(null);
  return <section id={data.code} sx={styles.section} ref={hoverRef} data-cy={data.code} data-testid="visual-block">
        <div sx={styles.imageHolder} ref={ref}>
          {RenderMedia(videos.video ? videos.thumbnail : images, videos.video ? videos.video : BLANK_VIDEO_OBJECT, true, videos.video ? thumbnailsWithBlur : imagesWithBlur, header, isFirst)}
        </div>
        <div sx={styles.contentHolder}>
          <div sx={styles.content}>
            <Heading h={isFirst ? 1 : 2} align="left" color={titleColor} addSx={styles.styledHeading}>
              <span sx={styles.headerText(titleColor, data.headerBackgroundColor)}>{data.header}</span>
              <span sx={styles.subHeaderText(titleColor, data.headerBackgroundColor)}>{data.subHeader}</span>
            </Heading>
          </div>
          {subpages && <VisualBlockNavigation activeSlug={activeSlug} categorySlug={categorySlug} subpages={subpages} setNewActiveSlug={setNewActiveSlug} hasProducts={hasProducts} />}
        </div>
        {data.voxboxButton && <VoxboxWidget hoverRef={hoverRef} />}
      </section>;
});
VisualBlock.displayName = 'VisualBlock';
export default VisualBlock;